// src/utils/payzone.ts
export function submitPaywallForm(
  paywallUrl: string,
  payloadJson: string,
  signature: string
): void {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = paywallUrl;
  
  // Payzone DEEP_LINK API expects 'payload' and 'signature' fields
  form.enctype = "application/x-www-form-urlencoded";

  // Field 1: payload
  const payloadInput = document.createElement("input");
  payloadInput.type = "hidden";
  payloadInput.name = "payload";          // 👈 'data' ki jagah 'payload'
  payloadInput.value = payloadJson;
  form.appendChild(payloadInput);

  // Field 2: signature
  const sigInput = document.createElement("input");
  sigInput.type = "hidden";
  sigInput.name = "signature";
  sigInput.value = signature;
  form.appendChild(sigInput);

  document.body.appendChild(form);
  form.submit();
}